import type {
  RouteLocationNormalized,
  RouteLocationRaw,
  LocationQueryRaw,
  RouteParamsRaw,
} from 'vue-router';

const REDIRECT_ROUTE_KEY = 'redirectAfterLoginRoute';
const LAST_PROTECTED_ROUTE_KEY = 'lastProtectedRoute';

export interface RedirectAfterLoginRoute {
  name?: string;
  query?: LocationQueryRaw;
  params?: RouteParamsRaw;
}

const safeParseRoute = (raw: string | null): RedirectAfterLoginRoute | null => {
  if (!raw) return null;

  try {
    return JSON.parse(raw) as RedirectAfterLoginRoute;
  } catch (error) {
    console.error('Не удалось распарсить route из localStorage:', error);
    return null;
  }
};

export const setRedirectAfterLoginRoute = (
  to: RouteLocationNormalized,
  customParams: RouteParamsRaw | null = null,
): void => {
  const params = customParams || (to.params as RouteParamsRaw);

  const payload: RedirectAfterLoginRoute = {
    name: to.name ? String(to.name) : 'Home',
    query: to.query,
    params,
  };

  localStorage.setItem(REDIRECT_ROUTE_KEY, JSON.stringify(payload));
};

export const getRedirectAfterLoginRoute = (): RedirectAfterLoginRoute | null => {
  const route = safeParseRoute(localStorage.getItem(REDIRECT_ROUTE_KEY));
  localStorage.removeItem(REDIRECT_ROUTE_KEY);

  return route;
};

export const setLastProtectedRoute = (
  to: RouteLocationNormalized,
  customParams: RouteParamsRaw | null = null,
): void => {
  const params = customParams || (to.params as RouteParamsRaw);

  const payload: RedirectAfterLoginRoute = {
    name: to.name ? String(to.name) : 'Home',
    query: to.query,
    params,
  };

  localStorage.setItem(LAST_PROTECTED_ROUTE_KEY, JSON.stringify(payload));
};

export const getLastProtectedRoute = (): RedirectAfterLoginRoute | null => {
  return safeParseRoute(localStorage.getItem(LAST_PROTECTED_ROUTE_KEY));
};

export const clearLastProtectedRoute = (): void => {
  localStorage.removeItem(LAST_PROTECTED_ROUTE_KEY);
};

export const clearRedirectAfterLoginRoute = (): void => {
  localStorage.removeItem(REDIRECT_ROUTE_KEY);
};

export const normalizeRedirectRoute = (
  route: RedirectAfterLoginRoute | null,
  baseParamName: string,
  baseValue: string,
): RouteLocationRaw => {
  return {
    name: route?.name || 'Home',
    ...(route?.query ? { query: route.query } : {}),
    params: {
      ...(route?.params || {}),
      [baseParamName]: baseValue,
    },
  };
};